import api from "@/api";
import store from '@/store'
import {gioTracking} from "@/utilities/tools";

export const jumpOnlineService = ()=> {
    // 聊天窗口配置
    const CHAT_WINDOW_CONFIG = {
        name: 'newwindow',
        features: 'height=400,width=400'
    };

    // 默认聊天URL
    const DEFAULT_CHAT_URL = 'https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221';

    const openChatWindow = (url) => {
        window.open(url, CHAT_WINDOW_CONFIG.name, CHAT_WINDOW_CONFIG.features);
    };

    const userToken = store.state.user.userToken;
    api.page.getUDeskUrl({
        userName: userToken || "",
        source: 'MOBILE'
    })
    .then((res) =>{
        const { success, data } = res;
        const chatUrl = success ? (data || DEFAULT_CHAT_URL) : DEFAULT_CHAT_URL;
        openChatWindow(chatUrl);

        gioTracking('track','evt_MainMenu', {
            menu:7,
            subMenu:1,
            desUrl: chatUrl
        })
        try {
            this._hmt.push(['_trackEvent', 'Customer_Service', 'Click', 'top', 1])
        } catch (error) {
            console.error(error)
        }
    }).catch(() => {
        openChatWindow(DEFAULT_CHAT_URL);
    });
}